import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'vehicleManagement',
  initialState: {
    // Vehicle Type
    vehicleTypeListLoading: false,
    vehicleTypeList: [],
    vehicleTypePagination: {},
    updateVehicleType: false,

    // Vehicle Facility
    vehicleFacilityListLoading: false,
    vehicleFacilityList: [],
    vehicleFacilityPagination: {},
    updateVehicleFacility: false,

    // Vehicle Category
    vehicleCategoryListLoading: false,
    vehicleCategoryList: [],
    vehicleCategoryPagination: {},
    updateVehicle: false,
    updateVehicleCategory: false,

    // Vehicle Subcategory
    vehicleSubCategoryListLoading: false,
    vehicleSubCategoryList: [],
    vehicleSubCategoryPagination: {},
    updateVehicleSubCategory: false,

    // Driver List
    driverListLoading: false,
    driverList: [],
    driverPagination: {},

    // Driver Details
    driverDetailsLoading: false,
    driverDetails: null,

    // Vehicles
    vehicleListLoading: false,
    vehicleList: [],
    vehiclePagination: {},
    vehicleDetailsLoading: false,
    vehicleDetails: null,

    // Vehicle SOS
    vehicleSosListLoading: false,
    vehicleSosList: [],
    vehicleSosPagination: {},
    vehicleSosDetailsLoading: false,
    vehicleSosDetails: null,
    updateVehicleSos: false,

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // ================= Vehicle Type (full CRUD) =================
    getVehicleTypeListApiData: (state) => {
      state.vehicleTypeListLoading = true
    },
    getVehicleTypeListApiSuccess: (state, { payload }) => {
      state.vehicleTypeListLoading = false
      state.vehicleTypeList = payload?.payload?.data || []
      state.vehicleTypePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleTypeListApiFailed: (state, { payload }) => {
      state.vehicleTypeListLoading = false
      state.ApiError = payload?.message
    },

    addVehicleTypeApiData: (state) => {
      state.vehicleTypeListLoading = true
      state.updateVehicleType = false
      state.modalOpen = false
    },
    addVehicleTypeApiSuccess: (state, { payload }) => {
      state.updateVehicleType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleTypeListLoading = false
      if (payload?.payload?.data) {
        state.vehicleTypeList.unshift(payload.payload.data)
      }
    },
    addVehicleTypeApiFailed: (state, { payload }) => {
      state.updateVehicleType = false
      state.vehicleTypeListLoading = false
      state.ApiError = payload?.message
    },

    updateVehicleTypeApiData: (state) => {
      state.vehicleTypeListLoading = true
      state.updateVehicleType = false
    },
    updateVehicleTypeApiSuccess: (state, { payload }) => {
      state.updateVehicleType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleTypeListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleTypeList = state.vehicleTypeList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateVehicleTypeApiFailed: (state, { payload }) => {
      state.updateVehicleType = false
      state.vehicleTypeListLoading = false
      state.ApiError = payload?.message
    },

    deleteVehicleTypeApiData: (state, { payload }) => {
      state.vehicleTypeList = state.vehicleTypeList.filter((item) => item.id !== payload?.id)
      state.updateVehicleType = false
    },
    deleteVehicleTypeApiSuccess: (state, { payload }) => {
      state.updateVehicleType = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteVehicleTypeApiFailed: (state, { payload }) => {
      state.updateVehicleType = false
      state.ApiError = payload?.message
    },

    toggleVehicleTypeStatusApiData: (state) => {
      state.vehicleTypeListLoading = true
      state.updateVehicleType = false
    },
    toggleVehicleTypeStatusApiSuccess: (state, { payload }) => {
      state.vehicleTypeListLoading = false
      state.updateVehicleType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleTypeList = state.vehicleTypeList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleVehicleTypeStatusApiFailed: (state, { payload }) => {
      state.vehicleTypeListLoading = false
      state.updateVehicleType = false
      state.ApiError = payload?.message
    },

    // ================= Vehicle Facility (full CRUD) =================
    getVehicleFacilityListApiData: (state) => {
      state.vehicleFacilityListLoading = true
    },
    getVehicleFacilityListApiSuccess: (state, { payload }) => {
      state.vehicleFacilityListLoading = false
      state.vehicleFacilityList = payload?.payload?.data || []
      state.vehicleFacilityPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleFacilityListApiFailed: (state, { payload }) => {
      state.vehicleFacilityListLoading = false
      state.ApiError = payload?.message
    },

    addVehicleFacilityApiData: (state) => {
      state.vehicleFacilityListLoading = true
      state.updateVehicleFacility = false
      state.modalOpen = false
    },
    addVehicleFacilityApiSuccess: (state, { payload }) => {
      state.updateVehicleFacility = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleFacilityListLoading = false
      if (payload?.payload?.data) {
        state.vehicleFacilityList.unshift(payload.payload.data)
      }
    },
    addVehicleFacilityApiFailed: (state, { payload }) => {
      state.updateVehicleFacility = false
      state.vehicleFacilityListLoading = false
      state.ApiError = payload?.message
    },

    updateVehicleFacilityApiData: (state) => {
      state.vehicleFacilityListLoading = true
      state.updateVehicleFacility = false
    },
    updateVehicleFacilityApiSuccess: (state, { payload }) => {
      state.updateVehicleFacility = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleFacilityListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleFacilityList = state.vehicleFacilityList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateVehicleFacilityApiFailed: (state, { payload }) => {
      state.updateVehicleFacility = false
      state.vehicleFacilityListLoading = false
      state.ApiError = payload?.message
    },

    deleteVehicleFacilityApiData: (state, { payload }) => {
      state.vehicleFacilityList = state.vehicleFacilityList.filter(
        (item) => item.id !== payload?.id,
      )
      state.updateVehicleFacility = false
    },
    deleteVehicleFacilityApiSuccess: (state, { payload }) => {
      state.updateVehicleFacility = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteVehicleFacilityApiFailed: (state, { payload }) => {
      state.updateVehicleFacility = false
      state.ApiError = payload?.message
    },

    toggleVehicleFacilityStatusApiData: (state) => {
      state.vehicleFacilityListLoading = true
      state.updateVehicleFacility = false
    },
    toggleVehicleFacilityStatusApiSuccess: (state, { payload }) => {
      state.vehicleFacilityListLoading = false
      state.updateVehicleFacility = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleFacilityList = state.vehicleFacilityList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleVehicleFacilityStatusApiFailed: (state, { payload }) => {
      state.vehicleFacilityListLoading = false
      state.updateVehicleFacility = false
      state.ApiError = payload?.message
    },

    // ================= Vehicle Category (full CRUD) =================
    getVehicleCategoryListApiData: (state) => {
      state.vehicleCategoryListLoading = true
    },
    getVehicleCategoryListApiSuccess: (state, { payload }) => {
      state.vehicleCategoryListLoading = false
      state.vehicleCategoryList = payload?.payload?.data || []
      state.vehicleCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleCategoryListApiFailed: (state, { payload }) => {
      state.vehicleCategoryListLoading = false
      state.ApiError = payload?.message
    },

    addVehicleCategoryApiData: (state) => {
      state.vehicleCategoryListLoading = true
      state.updateVehicleCategory = false
      state.modalOpen = false
    },
    addVehicleCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleCategoryListLoading = false
      if (payload?.payload?.data) {
        state.vehicleCategoryList.unshift(payload.payload.data)
      }
    },
    addVehicleCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleCategory = false
      state.vehicleCategoryListLoading = false
      state.ApiError = payload?.message
    },

    updateVehicleCategoryApiData: (state) => {
      state.vehicleCategoryListLoading = true
      state.updateVehicleCategory = false
    },
    updateVehicleCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleCategoryListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleCategoryList = state.vehicleCategoryList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateVehicleCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleCategory = false
      state.vehicleCategoryListLoading = false
      state.ApiError = payload?.message
    },

    deleteVehicleCategoryApiData: (state, { payload }) => {
      state.vehicleCategoryList = state.vehicleCategoryList.filter(
        (item) => item.id !== payload?.id,
      )
      state.updateVehicleCategory = false
    },
    deleteVehicleCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteVehicleCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleCategory = false
      state.ApiError = payload?.message
    },

    toggleVehicleCategoryStatusApiData: (state) => {
      state.vehicleCategoryListLoading = true
      state.updateVehicleCategory = false
    },
    toggleVehicleCategoryStatusApiSuccess: (state, { payload }) => {
      state.vehicleCategoryListLoading = false
      state.updateVehicleCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleCategoryList = state.vehicleCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleVehicleCategoryStatusApiFailed: (state, { payload }) => {
      state.vehicleCategoryListLoading = false
      state.updateVehicleCategory = false
      state.ApiError = payload?.message
    },

    // ================= Vehicle Subcategory (full CRUD) =================
    getVehicleSubCategoryListApiData: (state) => {
      state.vehicleSubCategoryListLoading = true
    },
    getVehicleSubCategoryListApiSuccess: (state, { payload }) => {
      state.vehicleSubCategoryListLoading = false
      state.vehicleSubCategoryList = payload?.payload?.data || []
      state.vehicleSubCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleSubCategoryListApiFailed: (state, { payload }) => {
      state.vehicleSubCategoryListLoading = false
      state.ApiError = payload?.message
    },

    addVehicleSubCategoryApiData: (state) => {
      state.vehicleSubCategoryListLoading = true
      state.updateVehicleSubCategory = false
      state.modalOpen = false
    },
    addVehicleSubCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleSubCategoryListLoading = false
      if (payload?.payload?.data) {
        state.vehicleSubCategoryList.unshift(payload.payload.data)
      }
    },
    addVehicleSubCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleSubCategory = false
      state.vehicleSubCategoryListLoading = false
      state.ApiError = payload?.message
    },

    updateVehicleSubCategoryApiData: (state) => {
      state.vehicleSubCategoryListLoading = true
      state.updateVehicleSubCategory = false
    },
    updateVehicleSubCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleSubCategoryListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleSubCategoryList = state.vehicleSubCategoryList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateVehicleSubCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleSubCategory = false
      state.vehicleSubCategoryListLoading = false
      state.ApiError = payload?.message
    },

    deleteVehicleSubCategoryApiData: (state, { payload }) => {
      state.vehicleSubCategoryList = state.vehicleSubCategoryList.filter(
        (item) => item.id !== payload?.id,
      )
      state.updateVehicleSubCategory = false
    },
    deleteVehicleSubCategoryApiSuccess: (state, { payload }) => {
      state.updateVehicleSubCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteVehicleSubCategoryApiFailed: (state, { payload }) => {
      state.updateVehicleSubCategory = false
      state.ApiError = payload?.message
    },

    toggleVehicleSubCategoryStatusApiData: (state) => {
      state.vehicleSubCategoryListLoading = true
      state.updateVehicleSubCategory = false
    },
    toggleVehicleSubCategoryStatusApiSuccess: (state, { payload }) => {
      state.vehicleSubCategoryListLoading = false
      state.updateVehicleSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleSubCategoryList = state.vehicleSubCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleVehicleSubCategoryStatusApiFailed: (state, { payload }) => {
      state.vehicleSubCategoryListLoading = false
      state.updateVehicleSubCategory = false
      state.ApiError = payload?.message
    },

    // ================= Vehicles =================
    getVehicleListApiData: (state) => {
      state.vehicleListLoading = true
    },
    getVehicleListApiSuccess: (state, { payload }) => {
      state.vehicleListLoading = false
      state.vehicleList = payload?.payload?.data || []
      state.vehiclePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleListApiFailed: (state, { payload }) => {
      state.vehicleListLoading = false
      state.ApiError = payload?.message
    },

    getVehicleDetailsApiData: (state) => {
      state.vehicleDetailsLoading = true
    },
    getVehicleDetailsApiSuccess: (state, { payload }) => {
      state.vehicleDetailsLoading = false
      state.vehicleDetails = payload?.payload
    },
    getVehicleDetailsApiFailed: (state, { payload }) => {
      state.vehicleDetailsLoading = false
      state.ApiError = payload?.message
    },

    addVehicleApiData: (state) => {
      state.vehicleListLoading = true
      state.updateVehicle = false
      state.modalOpen = false
    },
    addVehicleApiSuccess: (state, { payload }) => {
      state.updateVehicle = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleListLoading = false
      if (payload?.payload?.data) {
        state.vehicleList.unshift(payload.payload.data)
      }
    },
    addVehicleApiFailed: (state, { payload }) => {
      state.updateVehicle = false
      state.vehicleListLoading = false
      state.ApiError = payload?.message
    },

    updateVehicleApiData: (state) => {
      state.vehicleListLoading = true
      state.updateVehicle = false
    },
    updateVehicleApiSuccess: (state, { payload }) => {
      state.updateVehicle = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.vehicleListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleList = state.vehicleList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateVehicleApiFailed: (state, { payload }) => {
      state.updateVehicle = false
      state.vehicleListLoading = false
      state.ApiError = payload?.message
    },

    deleteVehicleApiData: (state, { payload }) => {
      state.vehicleList = state.vehicleList.filter((item) => item.id !== payload?.id)
      state.updateVehicle = false
    },
    deleteVehicleApiSuccess: (state, { payload }) => {
      state.updateVehicle = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteVehicleApiFailed: (state, { payload }) => {
      state.updateVehicle = false
      state.ApiError = payload?.message
    },

    toggleVehicleStatusApiData: (state) => {
      state.vehicleListLoading = true
      state.updateVehicle = false
    },
    toggleVehicleStatusApiSuccess: (state, { payload }) => {
      state.vehicleListLoading = false
      state.updateVehicle = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleList = state.vehicleList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleVehicleStatusApiFailed: (state, { payload }) => {
      state.vehicleListLoading = false
      state.updateVehicle = false
      state.ApiError = payload?.message
    },

    // ================= DRIVER LIST =================
    getDriverListApiData: (state) => {
      state.driverListLoading = true
    },
    getDriverListApiSuccess: (state, { payload }) => {
      state.driverListLoading = false
      state.driverList = payload?.payload?.data || []
      state.driverPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getDriverListApiFailed: (state, { payload }) => {
      state.driverListLoading = false
      state.ApiError = payload?.message
    },

    // ================= DRIVER DETAILS =================
    getDriverDetailsApiData: (state) => {
      state.driverDetailsLoading = true
    },
    getDriverDetailsApiSuccess: (state, { payload }) => {
      state.driverDetailsLoading = false
      state.driverDetails = payload?.payload
    },
    getDriverDetailsApiFailed: (state, { payload }) => {
      state.driverDetailsLoading = false
      state.ApiError = payload?.message
    },

    // ================= VEHICLE SOS ALERTS =================
    getVehicleSosListApiData: (state) => {
      state.vehicleSosListLoading = true
    },
    getVehicleSosListApiSuccess: (state, { payload }) => {
      state.vehicleSosListLoading = false
      state.vehicleSosList = payload?.payload?.data || []
      state.vehicleSosPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getVehicleSosListApiFailed: (state, { payload }) => {
      state.vehicleSosListLoading = false
      state.ApiError = payload?.message
    },

    getVehicleSosDetailsApiData: (state) => {
      state.vehicleSosDetailsLoading = true
    },
    getVehicleSosDetailsApiSuccess: (state, { payload }) => {
      state.vehicleSosDetailsLoading = false
      state.vehicleSosDetails = payload?.payload?.data || null
    },
    getVehicleSosDetailsApiFailed: (state, { payload }) => {
      state.vehicleSosDetailsLoading = false
      state.ApiError = payload?.message
    },

    resolveVehicleSosApiData: (state) => {
      state.vehicleSosListLoading = true
      state.updateVehicleSos = false
    },
    resolveVehicleSosApiSuccess: (state, { payload }) => {
      state.vehicleSosListLoading = false
      state.updateVehicleSos = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.vehicleSosList = state.vehicleSosList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    resolveVehicleSosApiFailed: (state, { payload }) => {
      state.vehicleSosListLoading = false
      state.updateVehicleSos = false
      state.ApiError = payload?.message
    },

    resetVehicleError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Vehicle Type
  getVehicleTypeListApiData,
  getVehicleTypeListApiSuccess,
  getVehicleTypeListApiFailed,
  addVehicleTypeApiData,
  addVehicleTypeApiSuccess,
  addVehicleTypeApiFailed,
  updateVehicleTypeApiData,
  updateVehicleTypeApiSuccess,
  updateVehicleTypeApiFailed,
  deleteVehicleTypeApiData,
  deleteVehicleTypeApiSuccess,
  deleteVehicleTypeApiFailed,
  toggleVehicleTypeStatusApiData,
  toggleVehicleTypeStatusApiSuccess,
  toggleVehicleTypeStatusApiFailed,

  // Vehicle Facility
  getVehicleFacilityListApiData,
  getVehicleFacilityListApiSuccess,
  getVehicleFacilityListApiFailed,
  addVehicleFacilityApiData,
  addVehicleFacilityApiSuccess,
  addVehicleFacilityApiFailed,
  updateVehicleFacilityApiData,
  updateVehicleFacilityApiSuccess,
  updateVehicleFacilityApiFailed,
  deleteVehicleFacilityApiData,
  deleteVehicleFacilityApiSuccess,
  deleteVehicleFacilityApiFailed,
  toggleVehicleFacilityStatusApiData,
  toggleVehicleFacilityStatusApiSuccess,
  toggleVehicleFacilityStatusApiFailed,

  // Vehicle Category
  getVehicleCategoryListApiData,
  getVehicleCategoryListApiSuccess,
  getVehicleCategoryListApiFailed,
  addVehicleCategoryApiData,
  addVehicleCategoryApiSuccess,
  addVehicleCategoryApiFailed,
  updateVehicleCategoryApiData,
  updateVehicleCategoryApiSuccess,
  updateVehicleCategoryApiFailed,
  deleteVehicleCategoryApiData,
  deleteVehicleCategoryApiSuccess,
  deleteVehicleCategoryApiFailed,
  toggleVehicleCategoryStatusApiData,
  toggleVehicleCategoryStatusApiSuccess,
  toggleVehicleCategoryStatusApiFailed,

  // Vehicle Subcategory
  getVehicleSubCategoryListApiData,
  getVehicleSubCategoryListApiSuccess,
  getVehicleSubCategoryListApiFailed,
  addVehicleSubCategoryApiData,
  addVehicleSubCategoryApiSuccess,
  addVehicleSubCategoryApiFailed,
  updateVehicleSubCategoryApiData,
  updateVehicleSubCategoryApiSuccess,
  updateVehicleSubCategoryApiFailed,
  deleteVehicleSubCategoryApiData,
  deleteVehicleSubCategoryApiSuccess,
  deleteVehicleSubCategoryApiFailed,
  toggleVehicleSubCategoryStatusApiData,
  toggleVehicleSubCategoryStatusApiSuccess,
  toggleVehicleSubCategoryStatusApiFailed,

  // Driver List
  getDriverListApiData,
  getDriverListApiSuccess,
  getDriverListApiFailed,

  // Driver Details
  getDriverDetailsApiData,
  getDriverDetailsApiSuccess,
  getDriverDetailsApiFailed,

  // Vehicles
  getVehicleListApiData,
  getVehicleListApiSuccess,
  getVehicleListApiFailed,
  getVehicleDetailsApiData,
  getVehicleDetailsApiSuccess,
  getVehicleDetailsApiFailed,
  addVehicleApiData,
  addVehicleApiSuccess,
  addVehicleApiFailed,
  updateVehicleApiData,
  updateVehicleApiSuccess,
  updateVehicleApiFailed,
  deleteVehicleApiData,
  deleteVehicleApiSuccess,
  deleteVehicleApiFailed,
  toggleVehicleStatusApiData,
  toggleVehicleStatusApiSuccess,
  toggleVehicleStatusApiFailed,

  // Vehicle SOS
  getVehicleSosListApiData,
  getVehicleSosListApiSuccess,
  getVehicleSosListApiFailed,
  getVehicleSosDetailsApiData,
  getVehicleSosDetailsApiSuccess,
  getVehicleSosDetailsApiFailed,
  resolveVehicleSosApiData,
  resolveVehicleSosApiSuccess,
  resolveVehicleSosApiFailed,

  resetVehicleError,
} = slice.actions

export default slice.reducer
